import { configureStore } from '@reduxjs/toolkit'
import userSlice from './slices/userSlice'
import deviseSlice from './slices/deviseSlice'
import mainAppSlice from './slices/mainAppSlice'
import billingSlice from './slices/billingSlice'

export const makeStore = () => {
  return configureStore({
    reducer: {
      user: userSlice,
      devise: deviseSlice,
      appStore: mainAppSlice,
      billing: billingSlice,
    },
  })
}
